import React from 'react';
import ReactExport from 'react-data-export';
import '../../views/ServiceReport.css';
import '../forms/Button.css';
import { getLocalizedString, getLocalizedDateTime } from '../../localization/LocalizedString';

const { ExcelFile } = ReactExport;
const { ExcelSheet, ExcelColumn } = ExcelFile;

const sortByDate = (items) => {
  return items.slice().sort((a, b) => {
    const aDate = new Date(a.createdAt);
    const bDate = new Date(b.createdAt);

    if (aDate > bDate) {
      return -1;
    }
    if (bDate > aDate) {
      return 1;
    }
    return 0;
  });
};

const ExportIssuesExcelButton = ({ currentLanguage, translate, data }) => {
  const sortedIssues = sortByDate(data);

  return (
    <ExcelFile hideElement filename={translate('service_report.search.type_issue')}>
      <ExcelSheet data={sortedIssues} name="Sheet1">
        <ExcelColumn label={translate('service_report.column_issue.date')} value={(col) => getLocalizedDateTime(new Date(col.createdAt), currentLanguage)} />
        <ExcelColumn label={translate('service_report.column_issue.type')} value={(col) => getLocalizedString(col.type, currentLanguage)} />
        <ExcelColumn label={translate('service_report.column_issue.description')} value={(col) => col.description} />
        <ExcelColumn label={translate('service_report.column_issue.customer')} value={(col) => col.destination.customer.name} />
        <ExcelColumn label={translate('service_report.column_issue.end_customer')} value={(col) => col.destination.companyName} />
        <ExcelColumn label={translate('service_report.column_issue.address')} value={(col) => col.destination.streetAddress} />
        <ExcelColumn label={translate('service_report.column_issue.city')} value={(col) => col.destination.city} />
        <ExcelColumn label={translate('service_report.column_issue.service_site')} value={(col) => (col.serviceSiteNo || []).join(',')} />
      </ExcelSheet>
    </ExcelFile>
  );
};

export default ExportIssuesExcelButton;



// WEBPACK FOOTER //
// ./src/components/servicereport/ExportIssuesExcelButton.jsx